import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import AnalysisModule from '../components/AnalysisModule';
import HeartlandMap from '../components/HeartlandMap';
import ChartCard from '../components/ChartCard';
import History from '../components/History';
import { initFirebase, saveAnalysis, subscribeToHistory } from '../firebase';

const Mackinder = () => {
  const [userId, setUserId] = useState(null);
  const [authStatus, setAuthStatus] = useState('Cargando autenticación...');
  const [analyses, setAnalyses] = useState([]);

  useEffect(() => {
    const init = async () => {
      const uid = await initFirebase();
      if (uid) {
        setUserId(uid);
        setAuthStatus(`✅ Conectado`);
        
        const unsubscribe = subscribeToHistory(uid, (data) => {
          setAnalyses(data);
        });
        
        return () => unsubscribe();
      } else {
        setAuthStatus('⚠️ No hay usuario autenticado');
      }
    };
    
    init();
  }, []);

  const handleSave = (query, result, type) => {
    if (userId) {
      saveAnalysis(userId, query, result, type);
    }
  };

  const surfaceData = {
    labels: ['Océano Mundo (9/12)', 'Tierras Emergidas (3/12)'],
    datasets: [{
      label: 'Distribución de Superficie',
      data: [9, 3],
      backgroundColor: ['#004e92', '#FFA600'],
      borderColor: '#ffffff',
      borderWidth: 2
    }]
  };

  const influenceData = {
    labels: ['Doctrina Lebensraum Nazi', 'Contención EE.UU.', 'Política Occidental Moderna'],
    datasets: [{
      label: 'Nivel de Influencia',
      data: [85, 95, 75],
      backgroundColor: ['#EF5675', '#7A5195', '#FF764A'],
      borderColor: '#000428',
      borderWidth: 1
    }]
  };

  return (
    <div className="container">
      <div style={{ marginBottom: '1rem' }}>
        <Link to="/">
          <button style={{
            padding: '0.5rem 1rem',
            borderRadius: '0.5rem',
            border: '1px solid rgba(148, 163, 184, 0.3)',
            background: 'rgba(30, 41, 59, 0.8)',
            color: '#cbd5e1',
            cursor: 'pointer',
            fontSize: '0.9rem'
          }}>
            ← Volver al Inicio
          </button>
        </Link>
      </div>
      <Header 
        title="El Teorema del Heartland" 
        subtitle="La Teoría Geopolítica que Definió el Siglo XX"
        authStatus={authStatus}
      />

      <section className="card" style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#004e92' }}>La Tesis Central</h2>
        <p style={{ fontSize: '1.5rem', fontWeight: 'black', fontStyle: 'italic', margin: '1rem 0', color: '#000428' }}>
          "Quien controle Europa del Este dominará el Heartland, quien controle el Heartland dominará la Isla-Mundo, quien controle la Isla-Mundo dominará el Mundo."
        </p>
        <p style={{ color: '#94a3b8' }}>- Sir Halford John Mackinder, 1919</p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '2rem', color: '#000428' }}>
          El Mapa Estratégico de Mackinder
        </h2>
        <div className="grid">
          <div className="card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🏰</div>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#004e92' }}>
              Heartland (Zona Pivote)
            </h3>
            <p>El núcleo inaccesible y decisivo de las tierras emergidas. Una fortaleza natural protegida del poder marítimo.</p>
          </div>
          <div className="card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🛡️</div>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#004e92' }}>
              Anillo Interior
            </h3>
            <p>O "Rimland". La zona de conflicto y transición que rodea al Heartland (Europa, Medio Oriente, India, China).</p>
          </div>
          <div className="card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🌊</div>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '0.5rem', color: '#004e92' }}>
              Anillo Exterior
            </h3>
            <p>Las tierras insulares y transoceánicas (América, Gran Bretaña, Japón, Australia) dominadas por el poder marítimo.</p>
          </div>
        </div>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '2rem', color: '#004e92' }}>
          La Fórmula del Dominio Global
        </h2>
        <div className="grid">
          <div className="card">
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '1rem', color: '#004e92' }}>
              Secuencia Estratégica
            </h3>
            <p style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
              La teoría propone una secuencia clara. El control de una región clave desencadena un efecto dominó que conduce a la hegemonía mundial.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ border: '2px dashed #4286f4', borderRadius: '0.5rem', padding: '0.75rem', width: '100%', textAlign: 'center' }}>
                Controlar Europa del Este
              </div>
              <div style={{ fontSize: '2rem', color: '#4286f4' }}>⬇️</div>
              <div style={{ border: '2px dashed #4286f4', borderRadius: '0.5rem', padding: '0.75rem', width: '100%', textAlign: 'center' }}>
                Dominar el Heartland
              </div>
              <div style={{ fontSize: '2rem', color: '#4286f4' }}>⬇️</div>
              <div style={{ border: '2px dashed #4286f4', borderRadius: '0.5rem', padding: '0.75rem', width: '100%', textAlign: 'center' }}>
                Dominar la Isla-Mundo
              </div>
              <div style={{ fontSize: '2rem', color: '#4286f4' }}>⬇️</div>
              <div style={{ border: '2px dashed #4286f4', borderRadius: '0.5rem', padding: '0.75rem', width: '100%', textAlign: 'center' }}>
                Controlar el Mundo
              </div>
            </div>
          </div>
          <ChartCard
            title="División de la Superficie"
            description="Mackinder dividió el mundo en Océano Mundo y Tierras Emergidas."
            type="doughnut"
            data={surfaceData}
            options={{ responsive: true, maintainAspectRatio: false }}
          />
        </div>
      </section>

      <section className="card" style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '1rem', color: '#004e92' }}>
          🗺️ Visualización del Heartland
        </h2>
        <p style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#cbd5e1' }}>
          Mapa interactivo mostrando el Heartland (rojo) y Europa del Este (amarillo), la puerta de entrada al poder mundial según Mackinder.
        </p>
        <HeartlandMap />
        <p style={{ textAlign: 'center', marginTop: '1rem', fontSize: '0.9rem', color: '#94a3b8', fontStyle: 'italic' }}>
          💡 Haz clic en las zonas coloreadas para ver más información
        </p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '2rem', color: '#004e92' }}>
          Legado e Influencia Histórica
        </h2>
        <p style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto 2rem', lineHeight: '1.7' }}>
          El pensamiento de Mackinder trascendió la academia, inspirando directamente algunas de las doctrinas geopolíticas más influyentes del siglo XX.
        </p>
        <div className="grid">
          <ChartCard
            title="Legado e Influencia Histórica"
            description="El pensamiento de Mackinder inspiró doctrinas geopolíticas del siglo XX."
            type="bar"
            data={influenceData}
            options={{ 
              indexAxis: 'y',
              responsive: true, 
              maintainAspectRatio: false,
              scales: {
                x: { beginAtZero: true, max: 100 }
              }
            }}
          />
        </div>
      </section>

      <AnalysisModule
        title="✨ Análisis de Escenarios con Heartland"
        description="Introduce un conflicto o evento actual para analizarlo bajo el marco de la Teoría del Pivote de Mackinder."
        inputType="textarea"
        category="mackinder"
        onSave={handleSave}
        type="scenario"
      />

      <AnalysisModule
        title="📚 Glosario Rápido de Geopolítica"
        description="Seleccione un término clave relacionado con la teoría de Mackinder."
        inputType="select"
        options={[
          'Heartland',
          'Rimland',
          'Isla Mundial',
          'Cordón Sanitario',
          'Lebensraum',
          'Geopolítica Marítima vs Terrestre'
        ]}
        category="mackinder"
        onSave={handleSave}
        type="concept"
      />

      <History analyses={analyses} />

      <div style={{ position: 'fixed', bottom: '20px', right: '20px', display: 'flex', gap: '10px', zIndex: 1000 }}>
        <Link to="/" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          🏠 Inicio
        </Link>
        <Link to="/mackinder01" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          Siguiente ➡️
        </Link>
      </div>
    </div>
  );
};

export default Mackinder;
